/* Homepage trust bar: cross-fading quotes. Namespace cro-tr.

   Paused while the tab is hidden and while the pointer or focus is inside, so
   a quote never changes mid-sentence. Dots are real buttons. */
(function () {
  function init(box) {
    if (box.dataset.on) return;
    box.dataset.on = '1';

    var slides = box.querySelectorAll('.cro-tr__q');
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-on'); return; }

    var wait = parseInt(box.dataset.every, 10) || 5000;
    var dots = box.parentNode.querySelectorAll('.cro-tr__dot');
    var i = 0, timer = null, hold = false;

    function show(n) {
      slides[i].classList.remove('is-on');
      if (dots[i]) dots[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on');
      if (dots[i]) dots[i].classList.add('is-on');
    }
    function tick() { if (!hold && !document.hidden) show(i + 1); }
    function start() { clearInterval(timer); timer = setInterval(tick, wait); }

    show(0);
    start();

    box.addEventListener('mouseenter', function () { hold = true; });
    box.addEventListener('mouseleave', function () { hold = false; });
    box.addEventListener('focusin', function () { hold = true; });
    box.addEventListener('focusout', function () { hold = false; });

    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function () { show(n); start(); });
      })(d);
    }
  }

  function run() {
    var all = document.querySelectorAll('[data-cro-fade]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  document.addEventListener('shopify:section:load', run);
})();
